//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalPropertiesReturnedToUseWidget = ({ count }: { count: number }) => {
  return (
    <>
      <StatCard title='Properties Returned To Use' stat={count} />
    </>
  );
};

export default TotalPropertiesReturnedToUseWidget;
